<template>
  <div class="grid data-container" :class="{ 'data-container--small': dataContainerSmall }">
    <div class="xs-6 data-container__block dea-text--left">
      <p class="dea-heading--medium__xm">Nome</p>
      <div class="dea-heading--regular__xm">{{ user.firstname }}</div>
    </div>
    <div class="xs-6 data-container__block data-container__block--right dea-text--left">
      <p class="dea-heading--medium__xm">Cognome</p>
      <div class="dea-heading--regular__xm">{{ user.lastname }}</div>
    </div>
    <div class="xs-6 data-container__block data-container__block--right dea-text--left">
      <p class="dea-heading--medium__xm">Email</p>
      <div class="dea-heading--regular__xm data-container__block data-container__block--email-field">
        {{ user.emails[0] }}
      </div>
    </div>
    <div v-if="user.phone" class="xs-6 data-container__block dea-text--left">
      <p class="dea-heading--medium__xm">Telefono</p>
      <div class="dea-heading--regular__xm">{{ user.phone }}</div>
    </div>
    <slot>
      <div v-if="user.current_schools && user.current_schools.length" class="xs-6 data-container__block dea-text--left">
        <p class="dea-heading--medium__xm">Scuola</p>
        <div v-for="school in user.current_schools" :key="school.id" class="dea-heading--regular__xm">
          {{ school.name }} ({{ school.city }})
        </div>
      </div>
      <div v-if="user.current_schools && user.current_schools.length" class="xs-6 data-container__block dea-text--left">
        <p class="dea-heading--medium__xm">Grado Scolastico</p>
        <div class="data-container__info">
          <div v-for="(grade, index) in schoolsGradeName()" :key="index">
            <span class="dea-heading--regular__xm">{{ grade }}</span>
          </div>
          <!-- FIXME: Do we need this? -->
          <ShowError v-if="showTargetError" class="dea-heading--regular__xm"
            >Il tuo grado scolastico non è compatibile col corso scelto</ShowError
          >
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: "PersonalData",
  props: {
    showTargetError: Boolean,
    user: {
      type: Object,
      default: () => ({}),
    },
    dataContainerSmall: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    schoolsGradeName() {
      const arrayOfGrades = [];
      /* eslint-disable array-callback-return */
      this.user.current_schools.filter(el => {
        if (el.grade && arrayOfGrades.indexOf(el.grade.name) === -1) {
          arrayOfGrades.push(el.grade.name);
        }
      });
      /* eslint-enable array-callback-return */

      return arrayOfGrades;
    },
  },
};
</script>
